module.exports = __webpack_public_path__ + "files/f8d8003d9663a4fe372ce4a3ac14f823.svg";